import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { averageTicketMessages } from 'pages/admin/demand/averageTicket/variables/averageTicketMessages';
import { useHistory } from 'react-router-dom';
import api from 'services/api/api';

export const createAverageTicket = async (body: any) => {
	const response = await api.post('ticketMedio', body);
	return response.data;
};

export const useCreateAverageTicket = () => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();

	return useMutation({
		mutationFn: (body: any) => createAverageTicket(body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['ticketMedio-list'] });
			queryClient.invalidateQueries({
				queryKey: ['sales-chanel-avarege-ticket-list'],
			});
			history.goBack();
			toast({
				title: averageTicketMessages.MSG_SUCCESS_AVERAGE_TICKET_CREATED
					.title,
				description:
					averageTicketMessages.MSG_SUCCESS_AVERAGE_TICKET_CREATED
						.text,
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			toast({
				title: averageTicketMessages.MSG_ERROR_AVERAGE_TICKET_CREATED
					.title,
				description: error.response.data[0].message,
				position: 'bottom-left',
				status: 'error',
				duration: 8000,
				isClosable: true,
			});
		},
	});
};
